<ng-container *ngIf="size !== 'small'">
  <span *ngIf="badgeValue; else textValue">{{ badgeValue }}</span>
  <ng-template #textValue>
    <span *ngIf="text">{{ text }}</span>
  </ng-template>
</ng-container>
